export default __webpack_public_path__ + "static/media/close.dbc7bf91.svg";